/*@flow*/
import getQueryKey from 'lib/getQueryKey';

export default (keyPath: string, fallback: any = null): any => {
  return getQueryKey(`load.${keyPath}`, fallback);
};
